module.exports = __webpack_public_path__ + "static/media/joshua-adam-nolette.01d8e3f6.jpg";